import DocNavigationController from "./DocNavigationController";
import IntroController from "./IntroController";
import InpageAnchor from "./InpageAnchor";
import HeaderController from "./HeaderController";
import NavigationController from "./NavigationController";
import ExamplesController from "./ExamplesController";
import StickyController from "./StickyController";
import StatsController from "./StatsController";
import SourceController from "./SourceController";
import ProgressController from "./ProgressController";

export default class Components {
	constructor() {
		this.docNavigationController = new DocNavigationController();
		this.examplesController = new ExamplesController();
		this.headerController = new HeaderController();
		this.inpageAnchor = new InpageAnchor();
		this.introController = new IntroController();
		this.navigationController = new NavigationController();
		this.progressController = new ProgressController();
		this.sourceController = new SourceController();
		this.StatsController = new StatsController();
		this.stickyController = new StickyController(
			Array.from(document.querySelectorAll(".doc-nav"))[0]
		);
	}
}



// WEBPACK FOOTER //
// ./Components/Components.js